import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

const COLUMN_WIDTH = '280px';

export const Container = styled('div')`
  border-right: 1px solid ${colours.neutral[300]};
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 5px;
  overflow-y: auto;
  padding: 15px;
  min-width: ${COLUMN_WIDTH};

  /* Hide scrollbar but keep scroll functionality */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  /* Webkit browsers (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: ${breakpoints.tablet}) {
    border-right: none;
    gap: 10px;
    padding: 0;
    min-width: unset;
  }
`;

export const EmptyState = styled('div')`
  margin-top: 15px;
  max-width: ${COLUMN_WIDTH};

  @media (max-width: ${breakpoints.tablet}) {
    margin-top: 0;
    max-width: unset;
  }
`;

export const PageTitle = styled('div')`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  min-height: 60px;
  width: 100%;
`;

export const Group = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const ProfileItem = styled('div')<{
  isActive?: boolean;
  isSelected?: boolean;
}>`
  align-items: center;
  background-color: ${({ isActive, isSelected }) => {
    if (isActive) return colours.neutral[200];
    if (isSelected) return colours.neutral[100];
    return 'transparent';
  }};
  border-radius: 100px;
  box-sizing: border-box;
  cursor: ${({ isActive }) => (isActive ? 'default' : 'pointer')};
  display: flex;
  gap: 10px;
  height: 60px;
  max-height: 60px;
  justify-content: space-between;
  padding: 10px 17px;
  width: 100%;
  position: relative;
  overflow: hidden;

  @media (max-width: ${breakpoints.tablet}) {
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    cursor: pointer;
    gap: 10px;
    height: auto;
    max-height: none;
    padding: 20px 15px;
  }

  ${({ isActive, isSelected }) =>
    !isActive &&
    !isSelected &&
    `
    @media (min-width: ${breakpoints.tablet}) {
      &:hover {
        background-color: ${colours.neutral[300]};
      }
    }
  `}

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
    pointer-events: none;

    @media (max-width: ${breakpoints.tablet}) {
      display: none;
    }
  }

  &:active::before {
    width: 300px;
    height: 300px;
    transition: width 0s, height 0s;
  }
`;

export const ProfileAvatar = styled('div')`
  width: 36px;
  height: 36px;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 30px;
  background-color: ${colours.neutral[100]};
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProfileInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
`;

export const ChevronIcon = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colours.neutral[600]};

  svg path {
    stroke-width: 2;
  }
`;
